import { useNavigate } from 'react-router-dom';
import { Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { paths } from '@/routes/paths';
import { useInstallPrompt } from './useInstallPrompt';
import { isStandalone } from './useServiceWorker';

/**
 * Install control in the top bar — always visible until the app runs standalone.
 *
 * Chrome’s address-bar install icon is easy to miss; this mirrors VCentrix-style apps
 * that put install next to notifications.
 */
export function InstallAppButton() {
  const navigate = useNavigate();
  const { available, install } = useInstallPrompt();

  if (isStandalone()) return null;

  return (
    <Button
      variant="ghost"
      size="icon"
      title={available ? 'Install BM-Work on this device' : 'Install BM-Work (open instructions)'}
      onClick={() => {
        if (available) void install();
        else navigate(paths.settings);
      }}
    >
      <Download aria-hidden className="size-4" />
      <span className="sr-only">Install app</span>
    </Button>
  );
}
